import axios from 'axios';
import { SERVER } from '../const';

async function getCategories(shop) {
  const resp = await axios.get(`${SERVER.URL}/api/public/shops/${shop.shopId}/categories/`);
  return resp.data.data;
}

async function getCategory(shop, categoryId) {
  const resp = await axios.get(`${SERVER.URL}/api/public/shops/${shop.shopId}/categories/${categoryId}/`, {});
  return resp.data.data;
}

async function getProducts(shop, category, searchKey) {
  const categoryId = category && category.id !== 'all' ? category.id : undefined;

  const resp = await axios.get(`${SERVER.URL}/api/public/shops/${shop.shopId}/items/`, {
    params: { category: categoryId, searchKey },
  });
  const products = resp.data.data.map((product) => {
    return {
      id: product.id,
      images: [product.image],
      name: product.name,
      price: product.price || product.mrp,
      mrp: product.mrp || product.price,
      stock: product.stock,
      stock_on_hold: product.stock_on_hold,
      unit: product.unit,
      options: product.config,
      type: product.type,
      tax: product.tax || 0,
      cess: product.cess || 0,
    };
  });
  return products;
}

async function getProduct(shop, productId) {
  const resp = await axios.get(`${SERVER.URL}/api/public/shops/${shop.shopId}/items/${productId}/`);
  return resp.data.data;
}

const ProductService = {
  getProducts,
  getCategories,
  getCategory,
  getProduct,
};

export default ProductService;
